// extracted by mini-css-extract-plugin
module.exports = {"TeamCellContainer":"TeamCell_TeamCellContainer__NwCxM","TeamItem":"TeamCell_TeamItem__n_f3C"};